/** Location state kept after a tool-prep image is committed onto /editor. */
export function toolPrepHandoffLocationState(locationState) {
  return {
    ...(locationState || {}),
    toolPrepApply: null,
    deferBackgroundRemoval: true,
  };
}
